import React, { useEffect, useState } from "react";
import { adminApi } from "../../lib/api";

export default function AdminLogs() {
  const [logs, setLogs] = useState([]);
  useEffect(() => { adminApi.get("/admin/logs").then((r) => setLogs(r.data)); }, []);

  return (
    <div>
      <h1 className="font-heading font-bold text-3xl tracking-tighter mb-6">Registro de actividad</h1>
      <div className="bg-white border border-border rounded-sm overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-brand-ink text-white"><tr><th className="text-left px-3 py-2">Fecha</th><th className="text-left px-3 py-2">Usuario</th><th className="text-left px-3 py-2">Acción</th><th className="text-left px-3 py-2">Detalle</th></tr></thead>
          <tbody>
            {logs.length === 0 ? <tr><td colSpan={4} className="py-10 text-center text-muted-foreground">Sin registros.</td></tr> :
             logs.map((l, i) => (
              <tr key={l.id} className={i % 2 ? "bg-secondary/40" : "bg-white"}>
                <td className="px-3 py-2 font-mono text-xs text-muted-foreground">{new Date(l.timestamp).toLocaleString("es-ES")}</td>
                <td className="px-3 py-2">{l.user_email}</td>
                <td className="px-3 py-2"><span className="text-xs bg-secondary px-2 py-0.5 rounded-sm font-mono">{l.action}</span></td>
                <td className="px-3 py-2 text-muted-foreground">{l.detail}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
